import { Component, OnInit } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[app-key]',
    templateUrl: './key.component.html',
    styleUrls: ['./key.component.scss'],
    standalone: true
})
export class KeyComponent {
}
